import type { FrenchDepartment } from '../../../entities/FrenchDepartment';
import { magellanClient } from '../../../infra/axios';

export async function getDepartments(): Promise<FrenchDepartment[]> {
  const response = await magellanClient.get<FrenchDepartment[]>('/departments');
  return response.data;
}
